import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import { color } from 'src/color/color'

export const useStyles = makeStyles((theme: Theme) => createStyles({
  button: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    padding: theme.spacing(1, 2),
    background: 'transparent',
    color: color('white'),
    '&:focus': {
      background: 'transparent',
      textDecoration: 'underline',
    },
    '&:hover': {
      background: 'transparent',
      textDecoration: 'underline',
    },
  },
  content: ({ isOpen }: { isOpen: boolean }) => ({
    padding: isOpen ? theme.spacing(0, 2, 1) : theme.spacing(0, 2),
  }),
  label: {
    color: 'inherit',
  },
  link: {
    color: color('white'),
    '&:active': {
      color: `${color('white')} !important`,
    },
    '&:focus': {
      color: `${color('white')} !important`,
    },
    '&:hover': {
      color: `${color('white')} !important`,
    },
  },
  section: {
    minHeight: '4rem',
    height: '100%',
    width: '100%',
    margin: theme.spacing(0, 0, 0.5),
    background: color('curious-blue'),
  },
  text: {
    margin: theme.spacing(0, 0.125, 0, 0),
    color: color('white'),
    letterSpacing: '0.38px',
  },
}))
